export default {
  tournament: state => state.tournament,
  getMatches: state => state.matches,
  getResults: state => state.results
}
